module.exports = __webpack_public_path__ + "static/media/arrowDown.5465e342.svg";